import { render, staticRenderFns } from "./GuidanceSleepDiaryKnowledge.vue?vue&type=template&id=52518188&"
import script from "./GuidanceSleepDiaryKnowledge.vue?vue&type=script&lang=js&"
export * from "./GuidanceSleepDiaryKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports